// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"242":"3c832dcc","325":"f8cd6eb3"}[chunkId] + ".css";
};